import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=693d6242&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693d6242')) {
      api.createRecord('693d6242', component.options)
    } else {
      api.reload('693d6242', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=693d6242&", function () {
      api.rerender('693d6242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/term/edit.vue"
export default component.exports